import {
    updownTansdateList, 
    shanghaiComposite, 
    updownMyBetinfo, 
    updownGamStatus,
    updownGamUp, 
    updownRecentGamInfo, 
    updownDaySumary 
} from '../../../api/wz/updown'
import {assign, isPlain, } from '../../../utils/base'
import {GetDateStr, splitStandardTime,get_now_time} from '../../../utils/base'
import { isArray } from 'util'

async function gameStart({commit},query){
    const R =  await updownGamUp(query)
    return R
}

async function loadDaysumary ({commit,state}, query){
    let {transDate} = state
    const R = await updownDaySumary({
        transDate
    })
    let summary = isPlain(R.summary)?R.summary : {}
    commit('update', {
        summary
    })
    return R 
}
async function loadTansdateList ({commit}, query){
    const R = await updownTansdateList({
        beginDate : GetDateStr(0),
        endDate : GetDateStr(20)
    })
    let transdateList = isArray(R.list) ? R.list : []
    
    commit('update', {
        transdateList
    })    
    return R 
}
//********************获取押注日期：transDate*********************************************
async function transDate({commit,state}){
    let {
        nowTime, 
        todayIsTransdate, 
        tomorrow,
        nowTimeSection
    } = state
	let transDate
	if(todayIsTransdate == 1){
		if( nowTimeSection == 0 || nowTimeSection ==1){
			transDate = nowTime.years + '-' + nowTime.months + '-' + nowTime.days
		} else if ( nowTimeSection == 2){
			transDate = tomorrow.years + '-' + tomorrow.months + '-' + tomorrow.days
        }
	}else{
		transDate = tomorrow.years + '-' + tomorrow.months + '-' + tomorrow.days
    }
    commit('update', {
        transDate
    })
	return transDate
}
//获取下个交易日的 日期
async function tomoorow({state, commit}){
    let list = state.transdateList
    let nextDate, arrayZero, todayIsTransdate, tomorrow = {}
      arrayZero = splitStandardTime(list[0].transDate).d
    if(arrayZero == state.nowTime.days){
        todayIsTransdate = 1
        nextDate = splitStandardTime(list[1].transDate) //获取下一个交易日
    }else{
        todayIsTransdate = 0
        nextDate = splitStandardTime(list[0].transDate) //获取下一个交易日
    }
    tomorrow.years = nextDate.y
    tomorrow.months = nextDate.m
    tomorrow.days = nextDate.d
    commit('update', {
        tomorrow,
        todayIsTransdate
    })
}

async function loadShangzheng ({commit}, query){
    const R = await shanghaiComposite(query)
    let shangzheng = R.shangzheng
    commit('update', {
        shangzheng
    })
    return R
}

async function loadBetinfo ({state, commit}, query){
    let {todayIsTransdate,nowTime,tomorrow} = state
    let {todayBeginDetail} = state.baseConf
    let detailTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayBeginDetail.hours,todayBeginDetail.minutes,todayBeginDetail.seconds)).getTime()
    let transDate
    if(todayIsTransdate == 1){
		if(nowTime.times > detailTimes){
			transDate = tomorrow.years + '-' + tomorrow.months + '-' + tomorrow.days;
		}else{
            transDate = nowTime.years + '-' + nowTime.months + '-' + nowTime.days;
		}
	}else{
		transDate = tomorrow.years + '-' + tomorrow.months + '-' + tomorrow.days;
	}
    query = assign({
        pid: 1,
        transDate
    }, query)
    const R = await updownMyBetinfo(query)
    let myBetInfo = {
        info : isPlain(R.info) ? R.info : null,
        nextInfo : isPlain(R.nextInfo) ? R.nextInfo : null
    }
    let nextBetInfo = isPlain(R.nextInfo) ? R.nextInfo : null
    commit('update', {
        myBetInfo,
        nextBetInfo
    })
    return R
}
async function loadGameStatus ({state, commit}, query){    
    let {transDate} = state
    query = assign({
        pid: 1,
        transDate
    }, query)
    let hasPut, myBetDetail
    const R = await updownGamStatus(query).then(() => {
        hasPut = 0
    }).catch(({error_code, Body}) => {
        if(error_code == 10150){
            hasPut = 1
            myBetDetail = Body.info
        }
    })
    commit('update', {
        hasPut,
        myBetDetail,
    })
    return R
}


async function loadBase({ dispatch }){
    dispatch('loadShangzheng',{indexCode : '000001.SS', fields : 'last_px,px_change,px_change_rate,open_px,preclose_px'})
    await dispatch('loadTansdateList')
    await dispatch('tomoorow') //触发获取交易日
    await dispatch('transDate') //下注日期
    await dispatch('loadDaysumary')
    //await dispatch('loadBetinfo')
    //await dispatch('loadGameStatus')
}
//********************判断当前时间处于哪个时间段*************************
function updateTimeSection({state,commit}){
    let todayEnd = state.baseConf.todayEnd
    let todayBegin = state.baseConf.todayBegin
    let nowTime = get_now_time()
    let todayEndTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayEnd.hours,todayEnd.minutes,todayEnd.seconds)).getTime()
    let todayBeginTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayBegin.hours,todayBegin.minutes,todayBegin.seconds)).getTime();
    let nowTimeSection
    if(nowTime.times < todayEndTimes){
        nowTimeSection = 0
    }else if(nowTime.times >= todayEndTimes && nowTime.times <= todayBeginTimes){
        nowTimeSection = 1
    }else if(nowTime.times > todayBeginTimes ){
        nowTimeSection = 2
    }
    commit('update', {
        nowTimeSection
    })
    return nowTimeSection    
     //console.log(nowTimeSection);
}
export default {
    loadBase,
    loadTansdateList,
    loadShangzheng,
    loadBetinfo,
    tomoorow,
    loadGameStatus,
    gameStart,
    loadDaysumary,
    transDate,
    updateTimeSection,
}